import { makeStyles } from '@material-ui/core/styles';

const useStyle = makeStyles((theme) => ({
  editableTitleContainer: {
    display: 'flex',
    margin: theme.spacing(1, 1, 1, 1),
  },
  editableTitle: {
    margin: theme.spacing(1, 1, 1, 1),
    paddingLeft: theme.spacing(0.5),
    fontWeight: 'bold',
    fontSize: '1.2rem',
    flexGrow: '1',
  },
  plainTitle: {
    margin: theme.spacing(1, 1, 1, 1),
    display: 'flex',
  },
  input: {
    margin: theme.spacing(1, 1, 1, 1),
    paddingLeft: theme.spacing(0.5),
    fontWeight: 'bold',
    fontSize: '1.2rem',
    '&:focus': {
      backgroundColor: '#ddd',
    },
  },
}));

export default useStyle;
